export const calculateTotalPageCount = (totalOrderCount, pageSize) =>
  Math.ceil(totalOrderCount / pageSize);

export const PREVIOUS = 'previous';
export const NEXT = 'next';
export const ORDER_HISTORY_DEFAULT_PAGE_SIZE = 5;
export const BUY_IT_AGAIN_DEFAULT_PAGE_SIZE = 9;

export const STARTING_PAGE_NUMBER = 1;

export const LEFT = 'left';
export const RIGHT = 'right';
